import type { AuthStore } from '@stores/auth/interfaces'
import type { AuthTokens } from '@ts-auth/interfaces'

import { AppRoute } from '@ts-routes/enums'

import { _applyTokens } from '@auth/apply-tokens'
import { _hydrateFromStorage } from '@auth/hydrate-from-storage'
import { _clearTokens } from '@auth/clear-tokens'
import { refreshTokens } from '@auth/refresh-tokens'

export const actions = {
  setLoading (this: AuthStore, payload: AuthStore['loading']): void {
    this.loading = payload
  },
  setEmail (this: AuthStore, payload: AuthStore['email']): void {
    this.email = payload
  },
  setEmailError (this: AuthStore, payload: AuthStore['errorEmail']): void {
    this.errorEmail = payload
  },
  setPassword (this: AuthStore, payload: AuthStore['password']): void {
    this.password = payload
  },
  setPasswordError (this: AuthStore, payload: AuthStore['errorPassword']): void {
    this.errorPassword = payload
  },
  setRemember (this: AuthStore, payload: AuthStore['remember']): void {
    this.remember = payload
  },
  async logout (this: AuthStore): Promise<void> {
    _clearTokens(this)
    await navigateTo(AppRoute.Login)
  },
  refreshTokens (this: AuthStore): Promise<string | void> {
    return refreshTokens(this)
  },
  _applyTokens (this: AuthStore, payload: AuthTokens): void {
    return _applyTokens(this, payload)
  },
  _clearTokens (this: AuthStore): void {
    return _clearTokens(this)
  },
  _hydrateFromStorage (this: AuthStore): void {
    return _hydrateFromStorage(this)
  },
}
